import {z} from 'zod';

import {CampaignEnvironment} from 'common/src/modules/campaignPlacements/placements.types';
import {PlacementCustomParamName} from 'common/src/modules/campaigns/campaigns.types';

const placementSchema = z.object({
  id: z.number().nullable().default(null).describe('Internal placement id, keep null!'),
  plcId: z.string().describe('Placement ID, mandatory'),
  name: z.string().describe('Placement name, mandatory'),
  dspId: z.number().describe('DSP ID, mandatory'),
  adSize: z
    .string()
    .optional()
    .describe('All or specific ad size (add size is provided as Width X Height - 300x250)'),
  environment: z.nativeEnum(CampaignEnvironment).describe('Environment, mandatory'),
  customParameters: z
    .array(
      z.object({
        name: z.nativeEnum(PlacementCustomParamName),
        value: z
          .union([z.string(), z.boolean()])
          .describe(
            'Value of the custom parameter. For dates use ISO string format, for booleans use boolean value.',
          ),
      }),
    )
    .optional()
    .describe(
      `Custom parameters for the placement. Array of objects with name and value properties. Name must be a valid parameter name (${Object.values(PlacementCustomParamName).join(', ')}). Value can be a string, DateTime object, or boolean. Examples: [{"name": "StartDateTime", "value": <DateTime>}, {"name": "animationLength", "value": "5"}]`,
    ),
});

export {placementSchema};
